import PubSub from "underpub-js";

var ListingRegions = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingRegions',
	};

	$.extend(true, this.options, options);

};

ListingRegions.prototype.init = function() {

	var self = this;

};

export default ListingRegions;
